import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { Claim } from '../../../models/Claim';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-update-claim-status-dialog',
  templateUrl: './update-claim-status-dialog.component.html',
  styleUrls: ['./update-claim-status-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    ReactiveFormsModule, 
    MatFormFieldModule, 
    MatInputModule,
    MatOptionModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule
  ]
})
export class UpdateClaimStatusDialogComponent implements OnInit {

  claimStatuses = [
    { status_id: 1, status_text: 'Draft' },
    { status_id: 2, status_text: 'In Progress' },
    { status_id: 3, status_text: 'Completed' }
  ];

  form!: FormGroup;
  currentStatus: any;
  claimStatusSelect!: any[];
  claim!: Claim;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<UpdateClaimStatusDialogComponent>,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.claim = this.data;

    this.currentStatus = this.claimStatuses.find(status => status.status_id === this.claim.status_id);
    this.claimStatusSelect = this.claimStatuses.filter(status => status.status_id != this.claim.status_id);
    this.initForm();
  }

  initForm() {
    this.form = this.formBuilder.group({
      status_id: ['', Validators.required]
    });
  }

  onSubmitClick() {
    let newStatusId = this.form.get('status_id')?.value;
    this.dialogRef.close(newStatusId);
  }

  onCancelClick() {
    this.dialogRef.close(0);
  }

  canUpdateClaim(): boolean {
    return (
      this.form.valid
    );
  }
}